module.exports = __webpack_public_path__ + "img/card_220310571.fb01ec13.png";